import { Controller } from "@hotwired/stimulus"
import consumer from "../../channels/consumer"
import { showNativeAlert } from "../../lib/bridge_utils"
import type { Subscription } from "@rails/actioncable"

interface QrChannelData {
  event: 'captured' | 'capture_failed'
  title: string
  message: string
}

// Connects to data-controller="pact-qr-channel"
export default class extends Controller {
  static values = { pactId: Number }
  declare readonly pactIdValue: number

  private channel?: Subscription

  connect() {
    this.channel = consumer.subscriptions.create(
      { channel: "PactQrChannel", pact_id: this.pactIdValue },
      {
        received: (data: QrChannelData) => this.handleData(data)
      }
    )
  }

  disconnect() {
    this.channel?.unsubscribe()
  }

  handleData(data: QrChannelData) {
    if (data.event === 'captured' || data.event === 'capture_failed') {
      const isError = data.event === 'capture_failed'
      showNativeAlert(this.element as HTMLElement, { 
        title: data.title, 
        message: data.message, 
        buttonText: "OK", 
        isDestructive: isError 
      })
      
      if (!isError) {
        // Refresh the page after a short delay to show the updated status
        setTimeout(() => {
          // If we are in Turbo environment, use Turbo.visit
          if (window.Turbo) {
             window.Turbo.visit(window.location.href, { action: "replace" })
          } else {
             window.location.reload()
          }
        }, 2000)
      }
    }
  }
}
